import './HomeyMap.css';
import config from './config.js';
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';
import { useState, useEffect} from 'react';
import { capitalizeFirstLetter } from "./util/Util";
import AccessRequestModal from './components/AccessRequestModal';

const HomeyMap = ({ homeys }) => {
    const [selectedHomey, setSelectedHomey] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [countdown, setCountdown] = useState();
    const isOnline = selectedHomey?.state === 'online';
    const installerUser = selectedHomey?.users.find(user => user?.role === 'installer');
    const isEnabled = installerUser?.enabled && new Date(installerUser?.enabledUntil) > new Date();
    const isConnecting = selectedHomey?.state === 'connecting';
    const dotColor = isOnline
        ? 'var(--color-green-600)'
        : isConnecting
            ? 'var(--color-orange)'
            : 'var(--color-red-500)';

    const handleMarkerClick = (homey) => {
        if (homey === selectedHomey) {
            handleCloseDrawer()
        } else {
            setSelectedHomey(homey);
        }
    };

    const handleCloseDrawer = () => {
        setSelectedHomey(null);
    };

    const requestAccess = async () => {
        if (!selectedHomey) return;
        setShowModal(true);
    }

    useEffect(() => {
        const interval = setInterval(() => {
            if (installerUser?.enabled && installerUser?.enabledUntil) {
                const diff = new Date(installerUser?.enabledUntil) - new Date();
                if (diff > 0) {
                    const hours = String(Math.floor(diff / 3600000)).padStart(2, '0');
                    const minutes = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
                    const seconds = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
                    const newCountdown = `${hours}:${minutes}:${seconds}`;
                    setCountdown(newCountdown);
                }
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [selectedHomey, installerUser?.enabled, installerUser?.enabledUntil]);

    return (
        <>
            <div className={`drawer ${selectedHomey ? 'open' : ''}`}>
                {selectedHomey && (
                    <>
                        <button className="close-btn" onClick={handleCloseDrawer}>
                            &times;
                        </button>
                        <div className="drawer-content">
                            <div className="image-container">
                                <img
                                    src={selectedHomey?.modelImage?.light}
                                    alt={selectedHomey?.model}
                                    className="homey-image"
                                />
                            </div>
                            <div className="row">
                                <div className="label">Name</div>
                                <div className="value">{selectedHomey?.name}</div>
                            </div>
                            <div className="row">
                                <div className="label">Version</div>
                                <div className="value">v{selectedHomey?.softwareVersion}</div>
                            </div>
                            <div className="row">
                                <div className="label">Status</div>
                                <div className="value">
                                    <span
                                        style={{
                                            marginRight: '8px',
                                            width: '10px',
                                            height: '10px',
                                            borderRadius: '50%',
                                            backgroundColor: dotColor,
                                            display: 'inline-block',
                                        }}
                                    />
                                    <span style={{ color: dotColor }}>
                                        {capitalizeFirstLetter(selectedHomey?.state)}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="drawer-footer">
                            {isEnabled ? (
                                <p className="HomeyActionTimer">Access expires in {countdown || '00:00:00'}</p>
                            ) : (
                                <button className="drawer-button" onClick={() => requestAccess()}>
                                    Request Access
                                </button>)}
                        </div>
                    </>
                )}
            </div>


            <div className="map-container">
                <APIProvider apiKey={config.googleMapsApiKey}>
                    <Map
                        defaultCenter={{ lat: 52.2125312, lng: 6.9009408 }}
                        style={{ width: '100%', height: '95vh' }}
                        defaultZoom={4}
                        gestureHandling={'greedy'}
                        disableDefaultUI={true}
                        options={{
                            styles: [
                                {
                                    featureType: 'road',
                                    elementType: 'labels',
                                    stylers: [{ visibility: 'off' }],
                                },
                            ],
                        }}
                    >
                        {homeys.map((homey, index) => (
                            <Marker
                                key={homey.id || index}
                                position={{
                                    lat: homey?.geolocation.latitude,
                                    lng: homey?.geolocation.longitude,
                                }}
                                icon={{
                                    url: homey.modelImage?.light,
                                    scaledSize: { width: 60, height: 60 },
                                }}
                                onClick={() => handleMarkerClick(homey)}
                            />
                        ))}
                    </Map>
                </APIProvider>
            </div>
            <AccessRequestModal
                open={showModal}
                onClose={() => setShowModal(false)}
                homey={selectedHomey}
            />
        </>
    );
};

export default HomeyMap;
